// extracted by mini-css-extract-plugin
module.exports = {"word":"split-text_word__WWxp2","char":"split-text_char__NoMCx"};